import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { clamp } from '../../../../../internal/utils';
import { useControlled } from '../../../../../internal/hooks';
import { asc } from '../../helpers';
import { equals } from 'ramda';
export function useSliderValueState(props) {
  var min = props.min,
    max = props.max,
    onChange = props.onChange;
  var _useControlled = useControlled({
      controlled: props.value,
      default: props.defaultValue
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    valueDerived = _useControlled2[0],
    setValueState = _useControlled2[1];
  var values = (Array.isArray(valueDerived) ? valueDerived : [valueDerived]).slice().sort(asc).map(function (value) {
    return clamp(value, min, max);
  });
  var range = values.length >= 2;
  var changeValue = function changeValue(nextValue) {
    if (equals(valueDerived, nextValue)) {
      return;
    }
    setValueState(nextValue);
    if (onChange) {
      onChange(nextValue);
    }
  };
  return {
    valueDerived: valueDerived,
    changeValue: changeValue,
    values: values,
    range: range
  };
}